var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateCatalogue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8399 35.842H3.0769V13.3888C3.0769 12.0582 4.15799 10.9771 5.48855 10.9771H34.3451C35.6757 10.9771 36.7567 12.0582 36.7567 13.3888V35.842H36.8399Z",
    fill: "#007E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2142 21.3721L13.3056 23.9501L13.1393 20.3742C13.1393 19.3763 13.472 18.3784 14.2204 17.6299L16.7152 15.2183L17.2142 21.3721Z",
    fill: "#7AFFEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7859 21.3721L26.6944 23.9501L26.8607 20.3742C26.8607 19.3763 26.5281 18.3784 25.7797 17.6299L23.2848 15.2183L22.7859 21.3721Z",
    fill: "#7AFFEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9585 21.2058C21.0395 21.2058 22.0375 21.3721 23.0354 21.6216C23.7838 18.9605 24.1996 16.0499 24.1996 12.973C24.1996 6.98545 22.5364 3.99168 19.9585 0.0831604C17.3805 3.99168 15.7173 6.98545 15.7173 12.973C15.7173 16.0499 16.1331 18.9605 16.8815 21.6216C17.8794 21.3721 18.9605 21.2058 19.9585 21.2058Z",
    fill: "#00BA9C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9584 16.2162C19.5426 16.2162 19.1268 16.5489 19.1268 17.0478V23.9501H20.79V17.0478C20.79 16.5489 20.4574 16.2162 19.9584 16.2162Z",
    fill: "#7AFFEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7048 9.06445C21.7048 9.97921 20.9564 10.8108 19.9584 10.8108C19.0437 10.8108 18.2952 9.97921 18.2952 9.06445C18.2952 8.14969 19.0437 7.31808 20.0416 7.31808C20.9564 7.40124 21.7048 8.14969 21.7048 9.06445Z",
    fill: "#06594C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2121 37.921C19.9584 37.921 21.289 36.5073 21.289 34.8441C21.289 33.0977 19.8753 31.7672 18.2121 31.7672H18.0457C17.3805 30.0208 15.7172 28.8566 13.8046 28.8566C11.3098 28.8566 9.23076 30.9356 9.23076 33.4304H8.56548C7.31808 33.4304 6.237 34.4283 6.237 35.7589C6.237 37.0063 7.23492 38.0873 8.56548 38.0873H9.23076",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7048 37.921C19.9584 37.921 18.6279 36.5073 18.6279 34.8441C18.6279 33.0977 20.0416 31.7672 21.7048 31.7672H21.8711C22.5364 30.0208 24.1996 28.8566 26.1123 28.8566C28.6071 28.8566 30.6861 30.9356 30.6861 33.4304H31.3514C32.5988 33.4304 33.6798 34.4283 33.6798 35.7589C33.6798 37.0063 32.6819 38.0873 31.3514 38.0873H30.7692",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.262V36.1746C0 37.5052 1.08108 38.5863 2.41164 38.5863H37.5052C38.8358 38.5863 39.9168 37.5052 39.9168 36.1746V34.262H0Z",
    fill: "#03CFAE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5343 29.7713C23.5343 31.7672 21.9543 33.3472 19.9584 33.3472C17.9626 33.3472 16.3825 31.7672 16.3825 29.7713C16.3825 27.7755 17.9626 26.1954 19.9584 26.1954C21.9543 26.1954 23.5343 27.7755 23.5343 29.7713Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9584 24.5322C19.2931 24.5322 18.711 25.1143 18.711 25.7796V29.106C18.711 29.7713 19.2931 30.3534 19.9584 30.3534C20.6237 30.3534 21.2058 29.7713 21.2058 29.106V25.7796C21.2058 25.1143 20.7069 24.5322 19.9584 24.5322Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCatalogue);
export default __webpack_public_path__ + "static/media/createCatalogue.1ec1958e88d740ac68132bf7021e6232.svg";
export { ForwardRef as ReactComponent };